import { UPDATE_TORCH_JSON } from "./torchJsonReducer"

export const updateTorchJson = (obj) => ({
    type: UPDATE_TORCH_JSON,
    payload: obj
})